module.exports = __webpack_public_path__ + "static/media/retrato_1.6ff690dd.jpg";